;(function($, undefined){
    'use strict';

    var rnn = window.rnn;
    var ios = '';
    var android = '';

    function initNavigationMenu() {
        // get the ios version
        ios = parseFloat(
            ('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0,''])[1])
            .replace('undefined', '3_2').replace('_', '.').replace('_', '')) || false;

        android = parseFloat(rnn.modules.utilities.getAndroidVersion());

        // setup the slide nav
        $('.hamburger-toggle, .close-nav').on('click', function (e) {
            e.stopPropagation();
            if ($('#mainMenu').hasClass('openNav')) {
                closeNav();
            } else {
                openNav();
            }
        });

        // Click anywhere to close side nav
        $(document).click(function(e) {
            if (e.target.className === "nav-overlay") {
                closeNav();
            }
        });

        // if we have a fixed nav in the header setup the scroll events
        var $fixedNav = $('.top-mobile');

        if ($fixedNav.length > 0) {
            $(window).scroll(function () {
                // Search in .container for any item that should be appended to the fixed nav on scroll.
                var $scrollNavExtra = $('.container .scrollNavExtra');

                if ($(this)[0].scrollY > 0) {
                    if ($scrollNavExtra.length > 0) {
                        $fixedNav.append($scrollNavExtra);
                    }
                }
            });
        }

        var $menuList = $('.navmenu .menu');

        // only do menu stuff if we have a menu
        if ($menuList.length){
            // setup the navbar user drop down
            $('.navbar .dropdown-toggle').dropdown().parent()
                .on('show.bs.dropdown', function () {
                    $('.navbar .dropdown-menu').slideDown();
                    $('.mobile-scrolling-nav').unbind('click');
                })
                .on('hide.bs.dropdown', function () {
                    /*
                        On mobile the click event fires immediately after binding and
                        we cant prevent propagation as normal due to the custom
                        dropdown event so I've added this var to prevent issues.
                    */
                    var justBound = true;
                    $('.navbar .dropdown-menu').slideUp();
                    $('.mobile-scrolling-nav').bind( "click", function () {
                        if (!justBound || ('ontouchstart' in document.documentElement) === false) {
                            $('.hamburger-toggle').click();
                        }
                        justBound = false;
                    });
                });
        }
    }

    function openNav() {
        var width = $(window).width();
        $('#mainMenu').addClass('openNav');
        $('html, body').css('overflow', 'hidden');
    }

    function closeNav() {
        var width = $(window).width();
        setTimeout(function() {
            $('html, body').css('overflow', 'initial');
        }, 600);
        $('#mainMenu').removeClass('openNav');
    }

    rnn.modules.register('nav', {
        init: initNavigationMenu
    });

})(jQuery);
